import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const MaterialStyled = styled.div`
  .material-body {
    display: flex;
    flex-direction: column;
  }
  .material-budget {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-left: 16px;
  }

  .material-task {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .material-1 {
    display: flex;
    padding: 16px 16px 0 0;
    .row1-delete {
      align-self: end;
    }
    .row1-content {
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 16px;
      width: 100%;
    }
  }

  .material-2 {
    display: grid;
    grid-template-columns: 2fr 1fr;
    padding: 0 16px 16px;
    gap: 16px;
    margin-left: ${(props) => (props.isGeneralUser ? "0" : "24px")};
    .left {
      display: grid;
      grid-template-columns: 0.75fr 0.25fr 1.75fr 0.75fr;
      gap: 16px;
      align-items: center;
    }
  }

  .add-material {
    display: flex;
    justify-content: end;
    background-color: ${COLOUR_CONSTANT.theme.purple.light};
    padding: 8px 16px;
  }

  .totalInput {
    .MuiInputBase-root {
      background-color: #efedfd;
    }
  }
`;
